import { startCar } from "@services/api";
import { alertPopup } from "@utils/popup";
import { Collapse, Pagination, Spin } from "antd";
import React from "react";

class StartMessagePopup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            messages: [],
            page: 1,
            perPage: 10,
            total: 0
        }
    }

    componentDidMount() {
        this.getMessages()
        window.addEventListener('click', this.closeOnOutClick)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.agent != this.props.agent ||
            (prevProps.agent && prevProps.agent.id != this.props.agent.id)) {
                this.getMessages()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.closeOnOutClick)
    }

    closeOnOutClick = (e) => {        
        if (e.target.id == 'start-message-wrapper') {
            this.props.close()
        }
    }

    getMessages = () => {

        const { page, perPage } = this.state
        const { agent } = this.props
        if (agent && agent.id) {
            this.setState({ loading: true }, () => {
                startCar.getStartAgentMessages({ agent_id: agent.id, page, perPage })
                .then((res) => {
                    const { messages: { data, total, page, perPage } } = res.data
                    this.setState({ messages: data, total, page, perPage })
                })
                .catch((error) => {
                    console.log('error', error.response);
                    alertPopup({ type: 'error', title: 'אירעה שגיאה בעת טעינת המידע', body: '' })
                })
                .finally(() => {
                    this.setState({ loading: false })
                })
            })
        }
    }

    paginate = (page, perPage) => {
        this.setState({ page, perPage }, this.getMessages)
    }

    messageTitle = (m) => {

        const unit = (type, text, width) => (
            <div style={{ margin: '0 0 0 10px', width: width || '', flex: width ? '' : '1' }}>
                <span style={{  }}>{`${type}:`}</span> 
                <span style={{ margin: '0 5px 0 0', fontWeight: '500' }}>{text}</span>
            </div>
        )

        return (
            <div style={{ display: 'flex', justifyContent: '' }}>
                {unit('נוצר ע״י', m.created_by, '')}
                {unit('שם הלקוח', m.from, '')}
                {unit('נושא', m.subject, '')}
                {unit('בתאריך', this.dateFormat(m.created_at), '185px')}
            </div>
        )
    }

    dateFormat = (str) => {
        console.log('date str', str);
        console.log('DATE', new Date(str).toLocaleString('he-IL'));
        str = new Date(str).toLocaleString('he-IL')
        
        let [date, time] = str.split(', ')
        date = date.split('.').join('/')
        time = time.substring(0, time.lastIndexOf(':'))
        return `${date} ${time}`
    }

    render () {
        const { loading, messages, total } = this.state
        let { agent, close } = this.props
        return agent ? (
            <div id="start-message-wrapper" style={{ ...styles.wrapper }}>
                <div style={{ ...styles.container }}>
                    <div onClick={close} style={{ ...styles.close }}>+</div>

                    <div style={{ ...styles.popupTitle }}>
                        <span>{"הודעות עבור סוכן - "}</span>
                        <span>{`${agent.name}`}</span>
                    </div>

                    
                        
                    <div style={{ ...styles.list }}>
                        {loading ?
                        <Spin /> :
                        <Collapse accordion>
                            {messages.map((item, idx) => {
                                let content = item.message || JSON.stringify({content: ""})
                                let { success, fails } = JSON.parse(item.sent_to || '{"success": [], "fails": []}')
                                const itemStyle = {}

                                if (success && success.length == 0) {
                                    itemStyle.border = 'solid red 2px'
                                    itemStyle.borderRadius = '6px'
                                }
                                    
                                return (
                                    <Collapse.Panel  key={idx.toString()}
                                        header={this.messageTitle(item)}
                                        style={itemStyle}
                                    >
                                        <div style={{ ...styles.column }}>
                                            <span style={{ fontWeight: '600' }}>{"תוכן ההודעה:"}</span>
                                            <p>{JSON.parse(content).content}</p>
                                        </div>
                                        {success && success.length ?
                                        <div style={{ ...styles.column }}>
                                            <span style={{ fontWeight: '600' }}>{"נשלח לכתובות:"}</span>
                                            {success.join(', ')}
                                        </div> : ''}
                                        {fails && fails.length ? 
                                        <div style={{ ...styles.column, marginTop: '20px' }}>
                                            <span style={{ fontWeight: '600' }}>{"שליחת ההודעה לכתובות הבאות נכשלה:"}</span>
                                            {fails.join(', ')}
                                        </div> : ''}
                                    </Collapse.Panel>
                                )
                            })}
                        </Collapse>}
                    </div>
                    <Pagination
                        style={{ marginTop: '20px' }}
                        size="small"
                        total={total}
                        onChange={(page, perPage) => this.paginate(page, perPage)}
                        onShowSizeChange={(page, perPage) => this.paginate(page, perPage)}
                        showSizeChanger
                    />

                </div>

            </div>
        ) : ''
    }
}


const styles = {
    wrapper: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        background: '#D3D5D679',
        top: 0,
        left: 0
    },
    container : {
        display: 'flex',
        flexDirection: 'column',
        width: '760px',
        minHeight: '300px',
        height: 'auto',
        borderRadius: '16px',
        background: 'white',
        border: 'solid #e3e3e3 1px',
        marginTop: '-160px',
        padding: '10px 10px 30px',
        zIndex: 1
    },
    close: {
        padding: '0',
        background: 'none',
        border: 'none',
        rotate: '45deg',
        fontSize: '32px',
        position: 'relative',
        cursor: 'pointer',
        alignSelf: 'start',
        margin: '-5px 8px 0 0'
    },
    popupTitle: {
        fontSize: '20px',
        margin: '0 0 18px 0'
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        height: '300px',
        overflowY: 'auto'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    }
}

export default StartMessagePopup